/* eslint-disable react/no-unescaped-entities */
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { ProfessionalEqualityIndex } from '../ProfessionalEqualityIndex';
import lifeAtSorare from '../assets/life-at-sorare.jpg';
import {
  Img,
  Section,
  StyledContainer,
  Text,
  Title,
  TwoColumnsContainer,
} from '../ui';

const StyledImg = styled(Img)`
  border-radius: var(--unit);
  border: 1px solid var(--c-nd-200-opaque);
`;

export const LifeAtSorare = () => (
  <Section $spacing>
    <StyledContainer>
      <TwoColumnsContainer image="left">
        <Vertical gap={3} center>
          <StyledImg
            src={lifeAtSorare}
            alt="Life at Sorare"
            style={{ aspectRatio: '1/1' }}
          />
          <ProfessionalEqualityIndex />
        </Vertical>
        <div>
          <Title>Life at Sorare</Title>
          <Text spacingAfter>
            On a day-to-day level, we aim to make life comfortable for our
            fast-moving team members through benefits like a flexible work
            location schedule and home workspace budget.
          </Text>
          <Text>
            Plus, our team meets on a regular basis for a range of work and
            social-focused events, including strategic planning meetings, game
            outings, staff celebrations, and an annual company retreat. We've
            got a range of programs to connect, grow, and celebrate our global
            team.
          </Text>
        </div>
      </TwoColumnsContainer>
    </StyledContainer>
  </Section>
);
